import React from "react";
import { Link } from 'react-router-dom';


const FoundationalPhilosophy = () => {
  const messages = [
    {
      title: "Love as a capital force",
      message:
        "Love is my greatest asset, a powerful force gained through spiritual practice (Sadhana). It is not a sign of weakness or mere emotion but a profound strength that empowers me.",
    },
    {
      title: "True Essence of Religion",
      message:
        "Despite religious abundance, fear persists due to lost divine connection. I reject distorted, fundamentalist beliefs. True religion is the universal discovery of the Self.",
    },
    {
      title: "Religion in Action",
      message:
        "Religion is not found in books or speeches but in lived practice.",
    },
    {
      title: "Soul Expansion",
      message:
        "To overcome life’s sorrows, expand your soul and embrace life fully.",
    },
    {
      title: "Inner Devotion",
      message:
        "True guidance comes from sincere devotion to your inner consciousness, not external sources.",
    },
    {
      title: "World-Centric Purpose",
      message:
        "Live and work with a global perspective to fulfill life’s true purpose.",
    },
    {
      title: "Mission for the Marginalized",
      message:
        "My purpose is to transform the unrighteous, serving those who depend on the Divine.",
    },
    {
      title: "Leave a Legacy",
      message:
        "You are not helpless—offer something meaningful to the world. Meditate on 'Tattvamasi'.",
    },
    {
      title: "Transcending the Ego",
      message:
        "Dive deep to uncover the broader 'I', sacrificing the limited ego in vast consciousness.",
    },
    {
      title: "Inner Transformation",
      message:
        "True human progress stems from an inner revolution, transforming the mind.",
    },
    {
      title: "Universal Religion",
      message:
        "Unity among religions is needed. True religion is universal and inclusive.",
    },
    {
      title: "Divine Aspiration",
      message:
        "Our goal is to embody love, selflessness, and divinity as God desires.",
    },
    {
      title: "Embrace Life’s Lessons",
      message:
        "Be open like the sky and trust the Divine. Learn from every life phase.",
    },
    {
      title: "Universal Significance",
      message:
        "The universe has inner value. Discovering this universal energy leads to spiritual realization.",
    },
    {
      title: "Soul’s Dynamo",
      message:
        "Soul expansion drives life. Spiritual knowledge is the ultimate aim and journey.",
    },
  ];
  const imageUrl = "img/content/about-08.jpg";

  return (
    <>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{
          backgroundImage: 'url("/img/banner/page-title-philosophy.jpg")',
        }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Foundational Philosophy</h1>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>Foundational Philosophy</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-style02">
        <div className="container">
          <div className="section-title01 mb-1-9 mb-lg-2-9 text-center">
            <h2 className="display-4 font-weight-800">Philosophy</h2>
          </div>
          <div className="row align-items-xl-center">
            <div className="col-lg-6 col-xl-7">
              <img
                src="img/service/service-details-7.jpg"
                alt="..."
                className="border-radius-10"
              />
            </div>
            <div className="col-lg-6 col-xl-5">
              <p>
                Shamayita Math has taken its birth from the ideals and ideology
                discovered by Revered Prabhuji throughout His life. This
                platform is entirely based on His divine philosophy and all the
                activities performed by this platform bear His thoughts in
                different actions.
              </p>
              <p>
                Spirituality is the sole binding force of all the domains in
                life. Mere belief in a miraculous power that will solve all our
                problems and make available all our demands is not at all about
                spiritualism. Rather it is the true belief of one on oneself.
                So, realization of self and its practical application in life is
                the definition of Spiritualism.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-style02 pt-1">
        <div className="container">
          <div className="section-title01 text-center">
            <h2 className="display-4 font-weight-800">Origins and Vision</h2>
          </div>
          <div className="row align-items-xl-center">
            <div className="col-lg-6 col-xl-5">
              <p>
                Shamayita Math emerged from the ideals and insights cultivated
                by Sri Sri Prabhuji over the course of his life. The
                organization is wholly grounded in his divine philosophy, with
                every initiative embodying his teachings through varied actions.
              </p>
            </div>
            <div className="col-lg-6 col-xl-7">
              <img src="img/content/about-15.jpg" alt="..." />
            </div>
          </div>
        </div>
      </section>

      <section className="about-style02 pt-1">
        <div className="container">
          <div className="section-title01 text-center">
            <h2 className="display-4 font-weight-800">
              Understanding Spiritualism
            </h2>
          </div>
          <div className="row align-items-xl-center">
            <div className="col-lg-6 col-xl-5">
              <p>
                Spirituality is the core force that integrates all facets of
                existence. It transcends the notion of relying on a miraculous
                power to solve problems or meet desires. True spiritualism is
                rooted in authentic self-belief, defined by the realization of
                the self and its meaningful application in everyday life.
              </p>
            </div>
            <div className="col-lg-6 col-xl-7">
              <img src="img/content/about-14.jpg" alt="..." />
            </div>
          </div>
        </div>
      </section>

      <section
        className="bg-img parallax map-hn"
        style={{
          backgroundImage: 'url("/img/bg/bg-04.jpg")',
        }}
      ></section>

      <section className="bg-secondary">
        <div className="container">
          <div className="section-title01 mb-1-9 mb-lg-8 text-center">
            <span>Our Team</span>
            <h2 className="mb-0 display-4 font-weight-800 lh-1 text-white w-lg-70 w-xl-60 w-xxl-50 mx-auto ls-minus-2px">
              Divine Messages of Revered Prabhuji
            </h2>
          </div>
        </div>
      </section>

      <section className="process-style02 pt-5">
        <div className="container">
          {/* Section Title */}
          <div
            className="section-title01 mb-1-9 mb-lg-2-9 text-center wow fadeInUp"
            data-wow-delay="100ms"
          >
            <h2 className="mb-0 display-4 font-weight-800 lh-1 w-md-90 w-lg-90 w-xl-90 w-xxl-90 mx-auto ls-minus-2px">
              Divine Messages of Revered Prabhuji
            </h2>
          </div>

          {/* Short Messages Section */}
          <div className="row mb-1-9 mt-n4 align-items-xxl-center">
            <div className="col-md-6 mt-4 wow fadeInUp" data-wow-delay="100ms">
              <div className="image-hover">
                <img
                  src="img/service/service-details-7.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
            <div className="col-md-6 mt-4 wow fadeInUp" data-wow-delay="100ms">
              <div className="ps-xxl-5">
                <ul className="list-style04 mb-0">
                  <li>
                    Love is my capital. I know it as a great force. I am
                    confident in it. It is not a weapon of the weak, it is
                    neither an emotion nor a feeling of the weak, but it is a
                    great force acquired through Sadhana.
                  </li>
                  <li>
                    There is no dearth of religious books and religious
                    exponents in the world today. Humanity is frightened and
                    frustrated today because Dharma has lost its divine spark
                    because it has ignored the sweet relationship between man
                    and God. This devilish state cannot continue for long. This
                    is a distorted religion. I never believe in such a religion.
                    And I never support fundamentalism. I never believe in
                    sectarianism. I am certain that bigotry is not religion,
                    religion is the universal feeling of man; it is a great
                    discovery of the Self.
                  </li>
                  <li>
                    Religion is not in books or speeches. It is in practice.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Long Messages Section */}
          <div className="row mb-1-9 mt-n4 align-items-xxl-center">
            <div className="col-md-12 mt-4 wow fadeInUp" data-wow-delay="150ms">
              <div className="ps-xxl-5">
                <ul className="list-style04 mb-0">
                  <li>
                    Expand the human soul and enjoy life. Only then you can
                    overcome the sorrows and troubles of mortal life.
                  </li>
                  <li>
                    Be sincere to your consciousness within. Nothing will come
                    from outside. The intense devotion to self-consciousness
                    will show you the path.
                  </li>
                  <li>
                    Life should be world-centric and work should be done aiming
                    at the world perspective. Then the purpose of life would be
                    fulfilled.
                  </li>
                  <li>
                    My descent is not for the righteous people but I have
                    descended to change the minds of the unrighteous people. I
                    am the server and companion of those who are helpless and
                    weak and those who depend fully upon the Lord.
                  </li>
                  <li>
                    Leave behind something in this world. You have many things
                    to give to the world. Do not be disillusioned thinking of
                    yourself as weak and helpless. Meditate on “Tattvamasi- That
                    Thou Art”. Try to know your source of work.
                  </li>
                  <li>
                    Plunging yourself into the innermost being, you will have to
                    discover the wider meaning of ‘I’. The smallest ‘I’ of
                    yourself, will have to be sacrificed amidst the vast
                    circumference of consciousness.
                  </li>
                  <li>
                    The inner revolution is the way of clear indication of human
                    progress. Total transformation of the mind is the root of
                    ascent and such ascent is the goal of life.
                  </li>
                  <li>
                    What is needed today is not a crusade but religious
                    conferences and a great union of religions. The prison bars
                    of those who want to make religion ritual-based,
                    nation-based, and sectarian-based by raising slogans in the
                    name of religion, have to be demolished. There is only one
                    shape of religion today— that is universal religion.
                  </li>
                  <li>
                    Our goal is to become a person of love, a selfless person,
                    divine person. This is the demand of God, our Father.
                  </li>
                  <li>
                    Be broad and munificent like the blue firmament. Let it come
                    whatever comes on the journey ahead, having full confidence
                    in the Lord. You should believe that no incident is absurd
                    or casual, and take lessons from the phases that you
                    undergo.
                  </li>
                  <li>
                    This Universe has meaning, a significance; it has an inner
                    value. This internal consciousness of values becomes our
                    power and inspiration. This universal power helps us to
                    reach the ultimate goal. True religion or spiritual
                    realization lies in the discovery of this power or energy.
                    This realization makes one divine. Then the consciousness,
                    feelings, and thoughts— all become universal-oriented, an
                    individual can transcend the boundary of race, color, and
                    sect.
                  </li>
                  <li>
                    Expansion of soul, indeed, is life’s dynamo and the
                    attainment of spiritual knowledge is the ultimate goal of
                    life. The struggle to reach that goal is called the
                    aspiration of spiritual life.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Dynamic Message Cards */}
          {[...Array(Math.ceil(messages.length / 3))].map((_, rowIndex) => (
            <div className="row mt-n1-9 pt-5" key={rowIndex}>
              {messages
                .slice(rowIndex * 3, rowIndex * 3 + 3)
                .map((item, index) => (
                  <div
                    className="col-md-6 col-xl-4 mt-1-9 wow fadeInUp"
                    data-wow-delay={`${150 + index * 100}ms`}
                    key={rowIndex * 3 + index}
                  >
                    <div className="process-block">
                      <h4 className="mb-md-4">
                        <span className="process-no">
                          {String(rowIndex * 3 + index + 1).padStart(2, "0")}.
                        </span>{" "}
                        {item.title}
                      </h4>
                      <p className="mb-0">{item.message}</p>
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </section>

      <section className="about-style02 pt-1">
        <div className="container">
          {/* First Row */}
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-3 display-4 font-weight-800 lh-1 ls-minus-2px">
                    Spiritualism in Practice
                  </h2>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp text-primary"
                  data-wow-delay="150ms"
                >
                  One of the important aspects of societal development is
                  development of ‘Self’. A person with a developed ‘mind’ and an
                  ‘awakened self’ is only able to lead a stable, balanced and
                  peaceful life.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  With an objective to develop and nurture the inner self,
                  Shamayita Math organizes spiritual discourses and seminars at
                  different times of the year. Spiritual classes are held on a
                  monthly basis in the main center at Bankura, Durgapur branch
                  and Kolkata branch where issues like attainment of self-power,
                  determination, and so on are discussed in small gatherings.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/about-16.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default FoundationalPhilosophy;
